import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ITEM_SIZE } from '#/components/Item/itemHelper';
import getCardByType from '#/utils/getCardByType';
import { actionClickItem } from '#/services/analytics';
import ContentGrid from '#/components/ContentGrid/DynamicSizeContentGrid';
import useI18n from '#/hooks/useI18n';
import { AuthContext } from '#/context/AuthContext';

const getCarouselConfig = ({ itemType, config, carouselWidth }) => {
  const width = carouselWidth || 1880; // 1880 to take padding into consideration (1920-40)
  const itemSize = ITEM_SIZE[itemType];
  const spacing = itemSize.itemSpacing || 15;
  const { width: itemWidth, height: itemHeight } = {
    ...itemSize,
    ...config.itemOptions
  };
  const height = itemSize.containerHeight + 20;

  return {
    itemHeight,
    itemWidth,
    spacing,
    width,
    height
  };
};

const CarouselShelf = ({
  config = {},
  carouselWidth,
  ds,
  items,
  itemType,
  nav = {},
  onClick
}) => {
  const { currentLocale = {} } = useI18n();
  const { dir } = currentLocale;

  const authContext = useContext(AuthContext);
  const isKidProfile = authContext.getUser()?.isKidProfile;
  let carouselConfig;

  if (itemType === 'categories' && isKidProfile) {
    carouselConfig = getCarouselConfig({
      itemType: `${itemType}Kids`,
      config,
      carouselWidth
    });
  } else {
    carouselConfig = getCarouselConfig({
      itemType,
      config,
      carouselWidth
    });
  }

  const Item = getCardByType(itemType);
  const { headPadding = 0, tailPadding = 0 } = config;
  // const useInternalArrows =
  //   items.length * carouselConfig.itemWidth +
  //     items.length * carouselConfig.spacing >=
  //   carouselConfig.width;

  return (
    <ContentGrid
      data={items}
      ds={ds}
      nav={{
        ...nav,
        id: config.id || nav.id,
        useLastFocus: true
      }}
      keyProperty="id"
      itemWidth={carouselConfig.itemWidth}
      itemHeight={carouselConfig.itemHeight}
      horizontal
      headPadding={headPadding}
      tailPadding={tailPadding}
      spacing={carouselConfig.spacing}
      width={carouselConfig.width}
      height={carouselConfig.height}
      onClick={item => {
        actionClickItem(item.data, config.displayText);
        return onClick(item.data);
      }}
      DisplayComponent={Item}
      displayComponentProps={{ type: itemType }}
      initialState={{
        // id: items?.[0]?.id,
        position: headPadding
      }}
      // useInternalArrows={useInternalArrows}
      dir={dir}
      buffer={6}
    />
  );
};

CarouselShelf.propTypes = {
  config: PropTypes.object,
  carouselWidth: PropTypes.number,
  ds: PropTypes.object,
  itemType: PropTypes.string,
  items: PropTypes.array,
  nav: PropTypes.object,
  onClick: PropTypes.func
};

export default CarouselShelf;
